import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../_virtual/_rollupPluginBabelHelpers.js';
import { LOCATION_CHANGE } from 'react-router-redux';
import { ActionTypes } from '../constants/actionTypes.js';
import { ApiReducer } from './ApiReducer.js';

function ApiReducerWithMemory() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  state = ApiReducer(state, action);

  switch (action.type) {
    case LOCATION_CHANGE:
      {
        var _state$pathActiveProp;

        var path = getPath();
        var props = loadActiveProps(path) || ((_state$pathActiveProp = state.pathActiveProps) === null || _state$pathActiveProp === void 0 ? void 0 : _state$pathActiveProp[path]);

        var pathProps = _objectSpread2({
          activePage: 1,
          activeFilters: {},
          activeSort: null,
          activeSearch: '',
          activeState: {}
        }, props);

        return _objectSpread2(_objectSpread2({}, state), pathProps);
      }

    case ActionTypes.SET_ACTIVE_PAGE:
      return setPathValue(state, 'activePage', action.activePage);

    case ActionTypes.SET_ACTIVE_FILTERS:
      return setPathValue(state, 'activeFilters', action.filters);

    case ActionTypes.SET_ACTIVE_SORT:
      return setPathValue(state, 'activeSort', action.sort);

    case ActionTypes.SET_ACTIVE_SEARCH:
      return setPathValue(state, 'activeSearch', action.search);

    case ActionTypes.SET_ACTIVE_STATE:
      return setPathValue(state, 'activeState', action.state);

    case ActionTypes.RESET_ACTIVE_PROPS:
      {
        var _path = getPath();

        removeActiveProps(_path);
        return _objectSpread2(_objectSpread2({}, state), {}, {
          pathActiveProps: _objectSpread2(_objectSpread2({}, state.pathActiveProps), {}, _defineProperty({}, _path, undefined))
        });
      }

    default:
      return state;
  }
}

function setPathValue(state, key, value) {
  var _state$pathActiveProp2;

  var path = getPath();

  var props = _objectSpread2(_objectSpread2({}, (_state$pathActiveProp2 = state.pathActiveProps) === null || _state$pathActiveProp2 === void 0 ? void 0 : _state$pathActiveProp2[path]), {}, _defineProperty({}, key, value));

  storeActiveProps(path, props);
  return _objectSpread2(_objectSpread2({}, state), {}, {
    pathActiveProps: _objectSpread2(_objectSpread2({}, state.pathActiveProps), {}, _defineProperty({}, path, props))
  });
}

function getPath() {
  return window.location.hash ? /#([^\?]*)(?:\??.*)/.exec(window.location.hash)[1] : '/';
}

function getSessionStorageKey(path) {
  return "activeProps_".concat(path);
}

function loadActiveProps(path) {
  var activeProps;

  try {
    activeProps = JSON.parse(sessionStorage.getItem(getSessionStorageKey(path)));
  } catch (e) {// ignore error
  }

  return activeProps;
}

function storeActiveProps(path, props) {
  sessionStorage.setItem(getSessionStorageKey(path), JSON.stringify(props));
}

function removeActiveProps(path) {
  return sessionStorage.removeItem(getSessionStorageKey(path));
}

export { ApiReducerWithMemory };